import axios from 'axios';
import { globalConfig } from '../configuration/config';

function getApiBaseUrl() {
  return globalConfig.config.common.api.replace(/\/+$/, '');
}

function getContentHtml(conversionAudit) {
  const contentHtml = conversionAudit?.contentHtml;

  if (typeof contentHtml !== 'string' || contentHtml.trim().length === 0) {
    return undefined;
  }

  return contentHtml;
}

// TODO(adr-20260821t1040z-conversion-audit-chat-delivery.md): Remove this
// browser seam after server-side deferred project binding supports durable
// idempotent delivery.
export async function sendConversionAuditMessage({
  calculationGuid,
  conversionAudit,
  projectGuid,
  signal,
}) {
  const contentHtml = getContentHtml(conversionAudit);

  if (contentHtml === undefined) {
    return undefined;
  }

  const response = await axios.post(
    `${getApiBaseUrl()}/ChatMessages/SendMessage`,
    {
      Content: contentHtml,
      // The backend has no HTML format; legacy Chat renders controlled Text content as HTML.
      FormatType: 'Text',
      GuidCalculation: calculationGuid,
      GuidProject: projectGuid,
      Type: 'System',
    },
    {
      signal,
      withCredentials: true,
    },
  );

  return response.data;
}

export async function sendBestEffortConversionAuditMessage({
  calculationGuid,
  conversionAudit,
  isAbortError,
  projectGuid,
  signal,
}) {
  try {
    const responseData = await sendConversionAuditMessage({
      calculationGuid,
      conversionAudit,
      projectGuid,
      signal,
    });

    return responseData === undefined
      ? { status: 'missing' }
      : { responseData, status: 'sent' };
  } catch (error) {
    if (signal?.aborted || isAbortError(error)) {
      throw error;
    }

    return {
      error,
      status: 'failed',
    };
  }
}
